import React, { memo } from "react";
import useStyles from "./styles";
import ImagesConfig from "components/ImagesConfig";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const RewardMerchandising = props => {
	const classes = useStyles();
	const { rewardLevel } = props;

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rewardText }}>
				Hạng mức {rewardLevel?.level}:
			</Grid>
			<Grid classes={{ root: classes.title }}>Điều kiện</Grid>
			<Grid classes={{ root: classes.description }}>
				<div
					style={{
						marginBottom: "10px",
						whiteSpace: "pre-wrap"
					}}
					dangerouslySetInnerHTML={{
						__html: rewardLevel?.description
					}}
				/>
			</Grid>
			<Grid classes={{ root: classes.title }}>Bạn sẽ được tặng</Grid>
			{rewardLevel?.merchandisingRewards?.map(product => (
				<Grid
					key={product?.giftProductGroupId}
					classes={{ root: classes.product }}
				>
					<Grid classes={{ root: classes.image }}>
						<ImagesConfig
							image={product?.image}
							imageDefault={Images.icProductDefault}
							width={45}
							height={45}
						/>
					</Grid>
					<Grid classes={{ root: classes.nameProduct }}>
						<span>
							{product?.quantity} {product?.unit}
						</span>{" "}
						{product?.name}
					</Grid>
				</Grid>
			))}
		</Grid>
	);
};

export default memo(RewardMerchandising);
